// FieldSelect Component

import React, { PureComponent } from 'react'

import Select from '../../common/select/select.jsx'

class FieldSelect extends PureComponent {
  static get propTypes () {
    return {}
  }

  static get defaultProps () {
    return {}
  }

  render () {
    const { ...others } = this.props

    return (
      <div className='field field-select'>
        <Select {...others} />
      </div>
    )
  }
}

export default FieldSelect
